"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFlag = exports.createEnvironmentFlags = exports.setFeatureFlagOverride = exports.getFeatureFlagOverrides = void 0;

var _storage = require("../util/storage");

var _environment = _interopRequireDefault(require("../util/environment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @ts-check

/** Where feature flag overrides get set in session storage */
var FEATURE_FLAG_OVERRIDES = 'zola_feature_flag_overrides';
/**
 * A featureFlag that can be on or off based on the environment.
 */

/**
 * Gets a lookup of feature flag overrides from session storage
 *
 * @memberof client
 *
 * @returns {EnvironmentFlagOverride} - Lookup of overriden feature flags.
 */
var getFeatureFlagOverrides = function getFeatureFlagOverrides() {
  try {
    return JSON.parse((0, _storage.getSessionStorage)(FEATURE_FLAG_OVERRIDES) || '') || {};
  } catch (_unused) {
    (0, _storage.deleteSessionStorage)(FEATURE_FLAG_OVERRIDES);
  }

  return {};
};
/**
 * Sets a feature flag override in session stroage
 *
 * @param {string} featureFlag - Name of the feature flag to override
 * @param {boolean} overrideValue - Value to set for the feature flag
 *
 * @memberof client
 * @returns {void}
 */


exports.getFeatureFlagOverrides = getFeatureFlagOverrides;

var setFeatureFlagOverride = function setFeatureFlagOverride(featureFlag, overrideValue) {
  if (!featureFlag) return;
  var overrides = getFeatureFlagOverrides();
  overrides[featureFlag] = overrideValue;
  (0, _storage.setSessionStorage)(FEATURE_FLAG_OVERRIDES, JSON.stringify(overrides));
};
/**
 * Creates an feature flag with fields for each environment
 *
 * @param {boolean} development
 * @param {boolean} staging
 * @param {boolean} production
 *
 * @returns {EnvironmentFlag}
 */


exports.setFeatureFlagOverride = setFeatureFlagOverride;

var createEnvironmentFlags = function createEnvironmentFlags() {
  var development = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var staging = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var production = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    development: development,
    staging: staging,
    production: production
  };
};

exports.createEnvironmentFlags = createEnvironmentFlags;
var environment = (0, _environment.default)();
/**
 * Gets the feature flag for the current environment.
 *
 * @param {FeatureFlags} flags - lookup of feature flags
 * @param {string} flag - flag to lookup
 *
 * @returns {boolean}
 */

var getFlag = function getFlag(flags, flag) {
  if (flags[flag]) {
    var overriddenFlags = getFeatureFlagOverrides();

    if (overriddenFlags[flag] !== undefined) {
      return Boolean(overriddenFlags[flag]);
    }

    return Boolean(flags[flag][environment]);
  }

  return false;
};

exports.getFlag = getFlag;